// postCharacterImageGeneration.ts
import apiRequest from './apiRequest';

export interface CharacterImageGenerationResponse {
  jobID: string;
  images: Array<{ imageURL: string }>;
}

export type ImageGenerationPayload = {
  filename?: string;
  fileExtension?: string;
  jobID?: string;
  prompt?: string;
};

export async function postCharacterImageGeneration(
  payload: ImageGenerationPayload,
) {
  return await apiRequest<CharacterImageGenerationResponse>(
    'mogen-orchestration',
    `/characters/imageGeneration`,
    {
      method: 'POST',
      body: JSON.stringify(payload),
    },
  );
}

export interface PrepareImageGenerationResponse {
  message: string;
  jobID: string;
  descriptionCount: number;
}

export type PrepareImageGenerationPayload = {
  prompt?: string;
  jobID?: string;
  fileExtension?: string;
};

export async function postPrepareCharacterImageGeneration(
  payload: PrepareImageGenerationPayload,
) {
  return await apiRequest<PrepareImageGenerationResponse>(
    'mogen-orchestration',
    `/characters/imageGeneration/prepare`,
    {
      method: 'POST',
      body: JSON.stringify(payload),
    },
  );
}

export type CompleteImageGenerationPayload = {
  jobID: string;
  prompt?: string;
  filename?: string;
};

export async function postCompleteCharacterImageGeneration(
  payload: CompleteImageGenerationPayload,
) {
  return await apiRequest<CharacterImageGenerationResponse>(
    'mogen-orchestration',
    `/characters/imageGeneration/submit`,
    {
      method: 'POST',
      body: JSON.stringify(payload),
    },
  );
}
